<template>
  <div class="group-list-item bg-white">
    <div class="d-flex align-items-center p-2" @click="setActiveGroupid()" v-if="inputData.id">
<!--      <router-link active-class="activeBg" class="flex-fill d-flex goup-lmenu-head" :to="'/group/index/'+inputData.id"-->
     <router-link active-class="activeBg" class="flex-fill d-flex goup-lmenu-head" :to="'/group/list/'+inputData.id+'?topic=0'"
      :class="{'activeBg':expand}">
        <el-avatar v-if="inputData.name" :src="inputData.avatar" shape="square" :size="40">
          {{ inputData.name.substring(0, 1).toUpperCase() }}
        </el-avatar>
        <div class="flex-fill d-flex align-items-center text-dark">
          <span class="px-2 group-title d-inline-block text-truncate ">
               <div class="float-left mr-1" v-if="$store.state.group.groupTopBar.is_private">
                  <i style="width:13px" class="el-icon-lock text-muted small"></i>
                </div>
            {{ inputData.name |textTrans }}
            <!--            <i v-if="inputData.is_private" class="el-icon-lock"></i>-->
          </span>
        </div>
      </router-link>
      <i  class="px-2 grouoexpand" :class="{'el-icon-arrow-up':expand, 'el-icon-arrow-down':!expand }">
        <!--       style="font-size:12px;color:grey;cursor:pointer;position:absolute;left:220px">-->

        <!--         style="font-size:12px;color:grey;cursor:pointer;position:absolute;right:30px">-->
      </i>
    </div>
    <div class="subitem" v-if="expand">
      <ul>
        <div>
          <router-link class="mt-2 mx-0 " tag="li" router-link-exact-active="activeBg"
                         :to="'/group/index/'+inputData.id"
                         :class="{'activeBg':$route.query.topicID==='0'}">

              <i class="el-icon-s-home"></i>首页<span style="font-size: 15px;color: #a9afbc">【主题 介绍 推广】</span><span style="font-size: 15px;color: #a9afbc"></span>
          </router-link>
          <router-link v-if="$store.state.group.groupTopBar.auth>=1  || $store.state.user.userinfo.UserLevel==6 || $store.state.group.groupTopBar.is_private===0" class="mt-2 mx-0 " tag="li" router-link-exact-active="activeBg"
                       :to="'/group/list/'+inputData.id+'?topic=0#'+postID"
                       :class="{'activeBg':$route.query.topicID==='0'}">

            <i class="el-icon-s-comment"></i>{{ $t('message').group.discuss }}<span style="font-size: 15px;color: #a9afbc">【所有帖子】</span>
          </router-link>
          <div>
            <li class="d-flex align-items-center mb-2 ml-0 mx-0" v-if="$store.state.group.groupTopBar.auth>=2">
              <div class="d-inline">
                <el-tooltip content="如何使用话题" placement="bottom">
                  <el-popover
                      placement="right"
                      trigger="click"
                      effect="light"
                      v-model="visiblepop">
                    <div class="recommend px-2">
                      <div class="mt-2">
                        <h2 class="font-weight-bold border-bottom pb-3">如何使用话题
                          <i role='button' @click="qxPopOver" class="el-icon-close mr-0 float-right"></i>
                        </h2>
                      </div>
                      <div><i class="el-icon-user"></i><span>群主和管理员可以使用话题来管理小组内容</span></div>
                      <div><i class="el-icon-magic-stick"></i><span>让成员更轻松地发现相关话题的帖子</span></div>
                      <div><i class="el-icon-notebook-2"></i><span>"添加话题"中输入您想要创建的话题，点击 <i
                          class="el-icon-check text-success"></i>#话题就创建好了。  </span></div>
                      <div><i class="el-icon-folder"></i><span>在此#话题下发出的帖子都从属于此#话题，并会带上此#话题标签</span></div>
                      <div><span>#话题下发的帖子除了本话题同时也会出现在#讨论</span></div>
                    </div>
                    <i size="medium" style="margin-top:3px;font-size:22px;font-weight:800;color: #4D8159!important;" data-placement="bottom"
                       class="el-icon-warning-outline text-secondary mr-2 tool" slot="reference"></i>
                  </el-popover>
                </el-tooltip>
              </div>
              <el-input
                  class="d-block mr-2"
                  style="width:173px;border-radius:5px;font-size:18px"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="medium"
                  :placeholder="$t('message').group.tag_new_btn"
                  @keyup.enter.native="handleInputConfirm(inputData.id)"
                  maxlength="7"
                  show-word-limit
              >
              </el-input>
              <div v-if="$store.state.group.groupTopBar.auth>=2">
                <span v-if="inputVisible">
                  <el-button type="text" icon="el-icon-check" style="font-weight:800;font-size:18px" class="text-success"
                             @click="handleInputConfirm(inputData.id)"></el-button>
                  <!--            <el-button type="text" icon="el-icon-close" @click="inputVisible=false" style="font-size: 12px;right: 12px;top:11px;position: absolute;"></el-button>-->
                </span>
                <!--          <el-button class="" style="width: 140px" v-else  size="small" @click="inputVisible=true">-->
                <!--            <i class=" el-icon-plus"></i>-->
                <!--            {{$t('message').group.tag_new_btn}}-->
                <!--          </el-button>-->
              </div>
            </li>
          </div>
          <div v-if="$store.state.group.groupTopBar.auth>=1  || $store.state.user.userinfo.UserLevel==6 || $store.state.group.groupTopBar.is_private===0"  id="content" :class="{ open : showContent }" class="pb-3">
            <router-link class="mx-0" tag="li" router-link-exact-active="activeBg"
                         :to="'/group/list/'+inputData.id+'?topic='+topic.id+'#'+postID"
                         :class="{'activeBg':$route.query.topicID==topic.id}"
                         :key="topic.id"
                         v-for="topic in dynamicTags.slice().reverse()">
              <el-tag
                  v-if="$store.state.group.groupTopBar.auth>=2||$store.state.user.userinfo.UserLevel==6"
                  class="tag-item d-inline-block text-truncate tagmax"
                  closable
                  effect="plain"
                  :disable-transitions="false"
                  @close="handleClose(topic)">#{{ topic.tag_tagID.name }}
              </el-tag>
              <el-tag
                  v-else
                  class="tag-item d-inline-block text-truncate tagmax"
                  effect="plain"
                  :disable-transitions="false"
                  @close="handleClose(topic)">#{{ topic.tag_tagID.name }}
              </el-tag>
            </router-link>
          </div>
          <el-divider v-if="dynamicTags.length>6 && $store.state.group.groupTopBar.auth>=1">
            <el-button   plain type="primary"  size="small" class="border-0 mx-auto w-100"  id="show-more" @click="showContent = !showContent">{{ showContent ? "收起更多" : "显示更多" }}</el-button>
            <!--          <el-button plain class="border-0 mx-auto w-100" type="primary" id="show-more" @click="showContent = !showContent">{{ showContent ? "收起" : "显示更多" }}<icon class="ml-2 el-icon-arrow-down"></icon></el-button>-->
          </el-divider>
        </div>
      </ul>
    </div>
  </div>

</template>
<script>
import {MessageBox, Tag,Divider} from 'element-ui';
import {textTrans} from '@/directives/textTrans.js';
export default {
  name: 'my-group-list-item',
  props: {
    inputData: {},
    // topic:Number,
    active: Boolean
  },
  components: {
    [Tag.name]: Tag,
    [Divider.name]: Divider,
  },
  watch: {
    inputDate(val) {
    },
    '$store.state.group.activeGroupID'(val) {
      this.init();
    }
  },
  created() {
    this.postID=this.$route.query.postID==undefined?0:this.$route.query.postID
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      visiblepop: false,
      dynamicTags: [],
      topicID: [],
      inputVisible: true,
      inputValue: '',
      expand: false,
      showContent: false
    };
  },
  filters: {
    textTrans(string) {
      return textTrans(string);
    }
  },
  methods: {
    setActiveGroupid() {
      this.$store.dispatch('group/setActiveGroupID', this.inputData.id);
      this.$router.push('/group/list/'+this.inputData.id+'?topic=0');
      this.expandGroup();
    },
    init() {
      if (this.inputData.id) {
        const active = this.inputData.id === this.$store.state.group.activeGroupID;
        this.expand = !active;
        this.expandGroup();
      };
      // this.$store.dispatch('group/GetArticalList', {groupinfoID: to.params.id, topicID: this.$route.query.topic, lastID:0})

    },
    expandGroup() {
      this.expand = !this.expand;
      if (this.expand) {
        this.rewriteTag()
      }
    },
    rewriteTag() {
      this.dynamicTags = []
      this.$store.dispatch('group/GetGroupTopic', this.inputData.id).then(res => {
        this.dynamicTags = res.data
      })
    },
    handleClose(topic) {
      MessageBox.confirm('确认删除？')
          .then(_ => {
            this.$store.dispatch('group/TopicRemove', {groupinfoID: this.inputData.id, id: topic.id}).then(r => {
              this.rewriteTag()
              this.$message.success('话题已删除');
            })
            // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
          })
          .catch(_ => {
          });

    },
    handleInputConfirm(id) {
      let tag = {
        tag_tagID: {name: this.inputValue}
      };
      if (this.inputValue) {
        this.dynamicTags.push(tag);
        this.$store.dispatch('group/TopicAdd', {groupinfoID: id, name: this.inputValue, topicID: this.$route.query.topic}).then(res => {
          if (res.status) {
            this.inputVisible = true;
            this.inputValue = '';
            this.$router.push('/group/list/' + this.inputData.id +'?topic='+res.data)
            this.$message.success('话题创建成功!');
            this.rewriteTag()
          }
          else {
            this.$message.error(res.error);    setTimeout(()=>{
              location. reload()
            },300)

          }
        })

        // this.dynamicTags.data=this.dynamicTags.data.reverse().concat(this.dynamicTags.data);//对话倒序排列
      }
    },
    qxPopOver() {
      this.visiblepop = false;
    },
  },
}

</script>
<style>
.group-list-item #content {
  max-height: 261px;
  overflow: hidden;

  /* Set Transitions */
  transition: max-height 0.7s;
}

.group-list-item #content.open {
  max-height: 100%;

  /* Set transitions */
  transition: max-height 0.7s;
}

.group-list-item #show-more {
  text-align: center;
  /*padding: 15px;*/
  /*margin: 10px auto;*/
}
.group-list-item [class*=" el-icon-arrow-up"] , .group-list-item [class*=" el-icon-arrow-down"] , .group-list-item [class*=" el-icon-close"] {
  font-size:15px;color:grey;cursor:pointer;position:absolute;left:230px
}
#WxcColor .group-list-item [class*=" el-icon-"] , #WxcColor .group-list-item [class*=" el-icon-arrow-down"] , #WxcColor .group-list-item [class*=" el-icon-close"] {
  font-size:15px;color:grey;cursor:pointer;position:absolute;left:198px
}
.group-list-item ul li .tagmax {
  max-width: 228px
}
.group-list-item {
  border-bottom: 5px solid #f6f6f6;
  -webkit-box-shadow: 0 1px 3px rgb(18 18 18 / 10%);
  box-shadow: 0 1px 3px rgba(18, 18, 18, .1);
}

.group-list-item ul li {
  margin: 0 8px 0 8px;
  padding: 8px 8px 8px 16px;
}

.group-list-item .tag-item {
  border: 0;
  background: transparent;
  color: #425466;
  padding-left: 0;
  font-size: 1.2rem;
}

.group-list-item .group-title {
  font-size: 1.2rem;
  max-width: 177px;
}

.group-list-item .max-height {
  max-height: 250px;
  overflow: scroll;
}

.tool title {
  position: absolute;
  border: 1px solid #333;
  background: #f7f5d1;
  padding: 1px;
  color: #333;
  display: none;
}

.activeBg {
  background: aliceblue;
  font-weight: bold;
}

.goup-lmenu-head {
  margin: -8px;
  padding: 8px;
}

.group-list-item i.el-tag__close.el-icon-close {
  position: absolute;
  top: 18px;
  right: 11px;
}
</style>